import I18nForLwText from './LwText'

export default class I18nForLwTime extends I18nForLwText {
  name = 'lw-time'
}
